import BaseService from '@/api/base.service';
import configApi from '@/api/config';
import grapePerksAppService from '@/api';

/**
 * @class ImportService
 */
class ImportService extends BaseService {
  constructor() {
    super({ baseUrl: configApi.baseRoutesUrls.imports });
  }

  /**
   * Cancel an import job
   * @param {string} importId - The ID of the import to cancel
   * @returns {Promise}
   */
  cancelImport = (importId) => grapePerksAppService.put(
    `${this.baseUrl}/${importId}/cancel`,
  ).then((resp) => resp.data);
}

const singletonInstance = new ImportService();

/**
 * @exports api/modules/import.service.js
 * */
export default singletonInstance;
